<template>
  <div v-bind="$attrs">

    <div :class="{ 'field': hasAddons, 'has-addons': hasAddons, 'mb-0': hasAddons }">
      <v-label
        v-if="label"
        :editable="editableLabel"
        :text="label"
        @update="$emit('update:label', $event)">
      </v-label>

      <div class="control" :class="{ 'is-expanded': isExpanded }">
        <input
          :errors="errors"
          class="input is-fullwidth"
          :class="textFieldClass"
          :type="type"
          :placeholder="placeholder"
          :value="value"
          @input="changeValue($event)"
          @blur="blur($event); validate($event.target.value)"
          @keyup.enter="keyupEnter($event); validate($event.target.value)"
          :required="required"
          :disabled="disabled"
          :readonly="readonly">
      </div>
      <slot v-if="hasAddons">
      </slot>
    </div>

    <div class="level w-100" v-if="counter || hasError">
      <div class="help has-text-danger pl-1">
        <div 
          v-for="(error, i) in errors"
          :key="i">
          {{ error }}
        </div>
      </div>
      <span
        class="help"
        :class="{ 'has-text-danger': charactersRem < 0 }"
        v-if="counter">
        {{characters}}/{{counterValue}}
      </span>
    </div>

  </div>
</template>

<script>
import validatable from '@/mixins/validatable'
import VLabel from '@/components/base/VLabel'

export default {
  props: {
    value: {
      type: [String, Number]
    },
    placeholder: {
      type: [String, Number],
      default: 'Input text here'
    },
    label: {
      type: [String, Number],
      default: null
    },
    editableLabel: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "text"
    },
    isSmall: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    isExpanded: {
      type: Boolean,
      default: false
    },
    hasAddons: {
      type: Boolean,
      default: false
    }
  },
  components: { VLabel },
  mixins: [validatable],
  computed: {
    textFieldClass() {
      return {
        'is-danger': this.hasError,
        'is-small': this.isSmall
      }
    }
  },
  methods: {
    blur(e) {
      this.$emit('blur', e.target.value);
    },
    keyupEnter(e) {
      this.$emit('enter', e.target.value);
    },
    changeValue(e) {
      this.$emit('input', e.target.value);
      this.validate(e.target.value);
    }
  }
}
</script>

<style scoped>
</style>
